// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606051533/js/" + chunkId + "." + {"44":"1b66beb8","225":"41aedba2","481":"aa702dcc","486":"041d10f5","770":"1ddcbd05"}[chunkId] + ".0.05720430900105722.chunk.js";
};